<template>
	<b-modal
		ref="select-tournament-modal"
		size="md"
		hide-footer
		@hidden="handleCloseModal"
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Seleccionar torneo | {{ beneficiary.name }}</div>
				<div class="d-flex gap-x-2">
					<b-button variant="outline-primary" @click="assignTournament">
						<FeatherIcon icon="SaveIcon" />
					</b-button>
					<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
						<FeatherIcon icon="XIcon" />
					</b-button>
				</div>
			</div>
		</template>
		<b-row style="min-height: 100px">
			<b-col cols="12">
				<b-form-group label="Torneo">
					<v-select
						class="border-primary rounded"
						label="name"
						:options="tournaments"
						:reduce="(opt) => opt.id"
						:clearable="false"
						multiple
						v-model="selectedTournament"
						placeholder="Seleccionar torneo"
					>
						<template v-slot:option="option">
							<img class="tournament_icon" :src="option.url_thumb" />
							<span class="ml-1">
								{{ option.name }}
							</span>
						</template>
						<template #selected-option="option">
							<img class="tournament_icon" :src="option.url_thumb" />
							<span class="ml-1">
								{{ option.name }}
							</span>
						</template>
					</v-select>
				</b-form-group>
			</b-col>
		</b-row>
	</b-modal>
</template>

<script>
import TournamentBeneficiariesService from "@/views/brain/tournament/views/beneficiaries/beneficiaries.service.js"

export default {
	name: "SelectTournamentModal",
	props: {
		beneficiary: {
			type: Object,
			default: () => ({}),
		},
		tournaments: {
			type: Array,
			required: true,
		},
	},
	data: () => ({
		isLoading: false,
		selectedTournament: null,
	}),

	computed: {},

	methods: {
		handleCloseModal() {
			this.$emit("close")
		},

		async assignTournament() {
			if (!this.selectedTournament) {
				this.showToast("warning", "top-right", "Advertencia", "AlertIcon", "Debe seleccionar un torneo")
				return
			}
			try {
				this.isLoading = true
				await TournamentBeneficiariesService.assignTournament({
					beneficiary_id: this.beneficiary.id,
					tournament_ids: this.selectedTournament,
				})
				this.showSuccessToast("Torneo asignado correctamente")
				this.$emit("close")
				this.$emit("refresh")
			} catch (error) {
				this.showToast("danger", "top-right", "Error", "AlertIcon", "Error al asignar torneo")
			} finally {
				this.isLoading = false
			}
		},
	},
	mounted() {
		this.selectedTournament = this.beneficiary.tournaments
			.filter((tournament) => tournament.id)
			.map((tournament) => tournament.id)
		this.$refs["select-tournament-modal"].toggle()
	},
}
</script>
<style lang="scss" scoped>
.tournament_icon {
	width: 40px;
	height: 40px;
	border-radius: 50%;
}
</style>
